import { render, staticRenderFns } from "./HospitalAdd.form.vue?vue&type=template&id=4724ce44&"
import script from "./HospitalAdd.form.vue?vue&type=script&lang=js&"
export * from "./HospitalAdd.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports